import { Component, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderService } from '../../Services/loader.service';

@Component({
  selector: 'av-global-loader',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss'],
})
export class GlobalLoaderComponent {
  protected readonly loader = inject(LoaderService);
}
